export const logout = theme => ({
  wrap: {
    padding: theme.spacing.unit,
    paddingTop: theme.spacing.unit * 4,
    textAlign: 'center',
  },
});
